import { Star } from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";

export const Marquee = () => {
  const { t } = useLang();
  const row = [...t.marquee, ...t.marquee];
  const Track = ({ hidden }) => (
    <div className="animate-marquee flex shrink-0 items-center whitespace-nowrap" aria-hidden={hidden}>
      {row.map((w, i) => (
        <span key={i} className="flex items-center">
          <span className="px-8 font-display text-3xl italic text-white/70 md:text-5xl">{w}</span>
          <Star className="h-4 w-4 text-gold-primary" fill="currentColor" />
        </span>
      ))}
    </div>
  );
  return (
    <div data-testid="editorial-marquee" className="relative flex overflow-hidden border-y border-gold-light/15 bg-ink-700/40 py-6">
      <Track />
      <Track hidden />
    </div>
  );
};
